import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

// eslint-disable-next-line import/no-anonymous-default-export
export default props => (
  <SvgIcon {...props} viewBox="0 0 23.109 23.124">
    <g id="Action" fill="#283983">
      <path
        id="path1010"
        d="m8.9958 0v2.3203a9.525 9.525 0 0 0-2.0743 0.85473l-1.6459-1.6536-1.9498 1.9523 0.0052 5e-3 -1.7436 1.741 1.635 1.6356a9.398 9.398 0 0 0-0.86765 2.0846h-2.3549v5.2307h2.344a9.525 9.525 0 0 0 0.85731 2.0665l-1.6511 1.6536 3.7042 3.7042 1.6567-1.6562a9.4245 9.4245 0 0 0 2.0846 0.84904v2.3363h5.2178v-2.3518a9.4562 9.4562 0 0 0 2.0557-0.8599l1.6485 1.6485 1.8226-1.8231-0.0052-5e-3 1.8707-1.8707-1.6588-1.6588a9.5806 9.5806 0 0 0 0.83871-2.0324h2.3229v-5.2306h-2.3125a9.525 9.525 0 0 0-0.84904-2.0608l1.6428-1.6407-3.7042-3.7042-1.6376 1.6382a9.4932 9.4932 0 0 0-2.0397-0.85215v-2.3203z"
        fill="#4db0e1"
      />
      <path
        id="path8-6-0"
        d="m0.081856 8.9161v5.2308h2.3125a9.525 9.525 0 0 0 0.84931 2.0611l-1.6431 1.6404 3.7042 3.7042 1.6378-1.6378a9.4932 9.4932 0 0 0 2.0399 0.85196v2.3204h5.2123v-2.3204a9.525 9.525 0 0 0 2.0743-0.8546l1.6457 1.6536 1.95-1.9526-16.404-16.264-1.8759 1.8759 1.6589 1.6589a9.5806 9.5806 0 0 0-0.83873 2.032z"
        fill="#4db0e1"
      />
      <path
        id="path10-3-0"
        d="m1.5875 5.2198 1.6351 1.6351a9.398 9.398 0 0 0-0.86783 2.0849h-2.3548v5.2308h2.3442a9.525 9.525 0 0 0 0.85725 2.0664l-1.651 1.6536 3.7042 3.7042 1.6563-1.6563a9.4245 9.4245 0 0 0 2.0849 0.84931v2.3363h5.2176v-2.3521a9.4562 9.4562 0 0 0 2.0558-0.8599l1.6484 1.6484 1.823-1.823-16.404-16.264z"
        fill="#283782"
        fillOpacity=".2"
      />
      <path
        id="path821"
        d="m13.081 13.524h-2.7983v-0.37982q0-0.63562 0.2558-1.124 0.2558-0.49609 1.0775-1.2557l0.49609-0.44958q0.44183-0.40308 0.64337-0.75964 0.20929-0.35657 0.20929-0.71313 0-0.5426-0.37207-0.84491-0.37207-0.31006-1.0387-0.31006-0.62787 0-1.3565 0.26355-0.72864 0.2558-1.5193 0.7674v-2.434q0.93793-0.32556 1.7131-0.48059 0.77515-0.15503 1.496-0.15503 1.8914 0 2.8835 0.77515 0.99219 0.7674 0.99219 2.2479 0 0.75964-0.30231 1.3643-0.30231 0.59686-1.0309 1.2867l-0.49609 0.44183q-0.5271 0.48059-0.68988 0.77515-0.16278 0.2868-0.16278 0.63562zm-2.7983 1.1472h2.7983v2.7595h-2.7983z"
        fill="#283983"
      />
    </g>
  </SvgIcon>
);
